<template>
  <div v-if="message" class="flash" :class="classMap">
    <base-icon v-if="type === 'success'" icon="check" />
    <base-icon v-if="type === 'failure'" icon="times" />
    <base-icon v-if="type === 'info'" icon="bell" />
    {{ message }}
    <ul v-if="list.length" class="mb-0 mt-1">
      <li v-for="(item, key) in list" :key="key">
        {{ formatItem(item) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FlashNotifications',

  data: () => ({
    list: [],
    message: '',
    timeout: null,
    type: ''
  }),

  mounted () {
    this.$flash.listen(flash => this.set(flash))
  },

  computed: {
    classMap () {
      return {
        'flash-success': this.type === 'success',
        'flash-failure': this.type === 'failure',
        'flash-info': this.type === 'info'
      }
    }
  },

  methods: {
    formatItem (item) {
      return this.$_.isPlainObject(item) ? this.$_.get(item, 'message') : item
    },

    showing () {
      return this.message !== ''
    },

    set (flash) {
      if (this.showing()) this.clear()

      if (this.$_.isObject(flash.message)) {
        const { data, message } = flash.message

        this.list = data || []
        this.message = message
      } else {
        this.list = []
        this.message = flash.message
      }

      this.type = flash.type
      this.timeout = setTimeout(() => this.clear(), flash.timeOut)
    },

    clear () {
      this.message = ''
      this.type = ''

      clearTimeout(this.timeout)
    }
  }
}
</script>
